const UpIconSVG = ({ className = "", stroke = "#333333" }) => {
  return (
    <svg
      className={className}
      width="11"
      height="7"
      viewBox="0 0 11 7"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.66846 6.021L5.71082 1.97889L9.75293 6.021"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default UpIconSVG;
